import { z } from 'zod';

import { PRAYER_SLOTS, type PrayerSlot, type Weekday } from '@/shared/model/enums';

/** One availability cell: a weekday × a prayer. */
export interface AvailabilitySlot {
  readonly weekday: Weekday;
  readonly prayer: PrayerSlot;
}

/** Stable string key for set membership, e.g. "2:asr". */
export const slotKey = (weekday: Weekday, prayer: PrayerSlot): string => `${weekday}:${prayer}`;

const rowSchema = z.object({
  weekday: z.number().int().min(0).max(6),
  prayer_slot: z.enum(PRAYER_SLOTS),
});

export function mapSlot(row: unknown): AvailabilitySlot {
  const r = rowSchema.parse(row);
  return { weekday: r.weekday as Weekday, prayer: r.prayer_slot };
}
